import React from "react";
import { Tag } from "antd";
import {
  ThunderboltOutlined,
  ArrowUpOutlined,
  MinusOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";

const priorityConfig = {
  urgent: { color: "error", icon: <ThunderboltOutlined />, label: "Urgent" },
  high: { color: "orange", icon: <ArrowUpOutlined />, label: "High" },
  normal: { color: "blue", icon: <MinusOutlined />, label: "Normal" },
  low: { color: "default", icon: <ArrowDownOutlined />, label: "Low" },
};

const PriorityBadge = ({ priority }) => {
  const config = priorityConfig[priority] || priorityConfig.normal;
  return (
    <Tag color={config.color} icon={config.icon}>
      {config.label}
    </Tag>
  );
};

export default PriorityBadge;
